import { render, staticRenderFns } from "./memberDetailInfo.vue?vue&type=template&id=809f0f3e&scoped=true&"
import script from "./memberDetailInfo.vue?vue&type=script&lang=js&"
export * from "./memberDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./memberDetailInfo.vue?vue&type=style&index=0&id=809f0f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809f0f3e",
  null
  
)

export default component.exports